'use client'
import type { ReactNode } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Table({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cx('pxs-scroll overflow-x-auto rounded-sm border border-line bg-surface shadow-[var(--shadow-xs)]', className)}>
      <table className="w-full border-collapse text-left text-[15px]">{children}</table>
    </div>
  )
}

export function Th({
  children,
  className,
  numeric,
}: {
  children?: ReactNode
  className?: string
  numeric?: boolean
}) {
  return (
    <th
      scope="col"
      className={cx(
        'border-b border-line bg-sunken px-4 py-2.5 text-[13px] font-medium tracking-[0.08em] text-ink-3 uppercase',
        numeric && 'text-right',
        className,
      )}
    >
      {children}
    </th>
  )
}

export function Td({
  children,
  className,
  numeric,
}: {
  children?: ReactNode
  className?: string
  numeric?: boolean
}) {
  return (
    <td
      className={cx(
        'border-b border-line px-4 py-2.5 align-middle text-ink-2',
        numeric && 'text-right',
        className,
      )}
    >
      {children}
    </td>
  )
}

export function Tr({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <tr className={cx('group transition-colors duration-100 last:[&>td]:border-b-0 hover:bg-canvas', className)}>
      {children}
    </tr>
  )
}

export function EmptyState({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="flex flex-col items-center gap-1.5 rounded-sm border border-dashed border-line-strong px-6 py-14 text-center">
      <div className="mb-1 grid h-9 w-9 place-items-center rounded-xs bg-sunken text-ink-3">
        <svg viewBox="0 0 16 16" className="h-4 w-4 fill-none stroke-current stroke-[1.2]">
          <rect x="2" y="2" width="12" height="12" rx="1" />
          <path d="M5 8h6M5 5.5h4M5 10.5h3" />
        </svg>
      </div>
      <p className="text-[15px] font-medium text-ink">{title}</p>
      {hint && <p className="text-[14px] text-ink-3">{hint}</p>}
    </div>
  )
}
